<template>
  <ul>
    <li
      v-for="(link, index) in payload"
      @mouseover="hoverWebsite"
      @mouseleave="unhoverWebsite"
      :key="index"
      class="sift-links__website-item middle-xs row"
    >
      <div class="col-xs-7">
        <a
          class="paragraph text-medium sift-links__main"
          :href="link.displayUri"
          target="_blank"
          rel="noopener"
        >
          {{ cleanUri(link.displayUri) }}
        </a>

        <ul class="sift-links_link-meta">
          <li class="paragraph paragraph--p4">{{ link.websiteUri }}</li>
          <li v-if="link.isRelative !== null && link.isSpam === undefined" class="paragraph paragraph--p4">{{ link.isRelative ? "relative" : "external" }}</li>
          <li class="paragraph paragraph--p4">
            <a :href="link.websiteUri" target="_blank" rel="noopener">
              <span>Visit link</span>
              <span class="icon-link"></span>
            </a>
          </li>
        </ul>
      </div>

      <div class="col-xs-5 end-xs sift-links__actions">
        <slot name="button-slot" :link="link">
          <app-btn
            v-if="cleanUri(link.uri) !== website.uri"
            class="sift-links__actions-sift"
            @click.native.prevent="siftAgain(cleanUri(link.displayUri))"
            :text="'Sift'"
            :options="{
              simple: true,
              icon: 'arrow-right'
            }"
            :loading="siftingAgain === cleanUri(link.displayUri)"
          ></app-btn>
        </slot>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import eventBus from '@/event-bus';

import Button from '@/components/UI/Button.vue';

export default {
  name: 'LinkList',
  data() {
    return {
      siftingAgain: null,
    };
  },
  components: {
    appBtn: Button,
  },
  props: {
    payload: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      website: 'UrlInput/siftedWebsite',
      relative: 'Filters/allowRelative',
    }),
  },
  created() {
    eventBus.$on('siftAgain', (payload) => {
      this.siftingAgain = payload;
    });

    eventBus.$on('stoppedSifting', () => {
      this.siftingAgain = null;
    });
  },
  methods: {
    ...mapMutations({
      clearLinks: 'UrlInput/clearLinks',
    }),
    hoverWebsite(e) {
      const item = e.target;
      if (item && item.querySelector('.sift-links__actions-sift')) {
        const btn = item.querySelector('.sift-links__actions-sift');
        if (btn.classList && btn.classList.contains('app-btn--simple')) {
          btn.classList.add('-hover');
        }
      }
    },
    unhoverWebsite(e) {
      const item = e.target;
      if (item && item.querySelector('.sift-links__actions-sift')) {
        const btn = item.querySelector('.sift-links__actions-sift');
        if (btn.classList && btn.classList.contains('app-btn--simple')) {
          btn.classList.remove('-hover');
        }
      }
    },
    siftAgain(w) {
      // if link is relative, add domain as prefix
      if (w.startsWith('/') || w.startsWith('#')) {
        // eslint-disable-next-line no-param-reassign
        w = this.website.websiteUri + w;
      }
      eventBus.$emit('siftAgain', w);
    },
    cleanUri(uri) {
      return uri ? uri.replace('https://', '').replace('http://', '').toLowerCase() : uri;
    },
  },
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to  {
  opacity: 0;
}
</style>
